@if (!hiddenHeader) {
<c-header class="header header-sticky border-bottom px-3 px-md-4 container-fluid" position="sticky">
  <c-container [fluid]="true" class="d-flex align-items-center">
    <!-- Phones only: opens the sidebar drawer. -->
    @if (showMenuToggle) {
    <button
      type="button"
      class="btn btn-link p-0 border-0 header-icon-btn d-md-none menu-toggle"
      cSidebarToggle="sidebar1"
      toggle="visible"
      aria-label="Open menu"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    }
    <c-header-nav class="ms-auto d-flex align-items-center" style="gap: 2px">
      <!-- Notifications -->
      <c-nav-item>
        <c-dropdown alignment="end" variant="nav-item">
          <button 
            [caret]="false" 
            cDropdownToggle 
            aria-label="Open notifications"
            class="btn btn-link p-0 border-0 header-icon-btn position-relative"
          >
            <i class="icon-bell" style="font-size: 1.25rem;">
              @if (notCount > 0) {
                <span
                  class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style="font-size: 0.6rem;"
                >
                  {{ notCount > 99 ? '99+' : notCount }}
                </span>
              }
            </i>
          </button>
          <div cDropdownMenu class="dropdown-menu-lg notifications-menu">
            <h6 class="dropdown-header text-center">
              <strong>You have {{ notifications.length }} notifications</strong>
            </h6>
            @if (notifications.length > 0) {
              @for (item of notifications; track item.id) {
                <button
                  type="button"
                  cDropdownItem
                  class="d-flex align-items-start p-3 border-bottom notification-item"
                  [class.bg-body-secondary]="!item.readed"
                  (click)="redirect(item)"
                >
                  <div class="flex-grow-1 me-2">
                    <div class="small text-muted mb-1">{{ item.timestamp }}</div>
                    <div class="text-wrap">
                      @if (item.name === 'log') {
                        {{ item.causer }} tagged you on work order #{{ item.company_id }}
                      }
                      @if (item.name === 'work-order') {
                        {{ item.causer }} assign you on work order #{{ item.company_id }}
                      }
                      @if (item.name === 'request') {
                        {{ item.causer }} assigned you on request #{{ item.company_id }}
                      }
                      @if (item.name === 'qb-pay-failed') {
                        The payment #{{ item.company_id }} failed to sync in QB, please try again or contact with your admin.
                      }
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary ms-auto"
                    (click)="removeNotification(item); $event.stopPropagation()"
                    aria-label="Remove notification"
                  >
                    <svg cIcon name="cilX" size="sm"></svg>
                  </button>
                </button>
              }
              <div class="dropdown-header p-0">
                <div class="row g-0">
                  <div class="col-6">
                    <button
                      type="button"
                      class="btn btn-link w-100 text-center border-end"
                      (click)="readAll()"
                    >
                      Mark all as read
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="button"
                      class="btn btn-link w-100 text-center"
                      (click)="clearAll()"
                    >
                      Clear all
                    </button>
                  </div>
                </div>
              </div>
            } @else {
              <div class="dropdown-item-text text-center py-4">
                <svg cIcon name="cilBell" size="xl" class="text-muted mb-2"></svg>
                <div class="text-muted">No notifications</div>
              </div>
            }
          </div>
        </c-dropdown>
      </c-nav-item>

      <!-- Theme Dropdown -->
      <c-nav-item>
        <ng-container *ngTemplateOutlet="themeDropdown" />
      </c-nav-item>

      <!-- Help/Support -->
      <c-nav-item>
        <button
          class="btn btn-link p-0 border-0 header-icon-btn"
          (click)="profile.wp_id ? redirectToWP(null) : checkWP(pwdTemplate)"
          cTooltip="Help & Support"
          placement="bottom"
        >
          <i class="far fa-question-circle" style="font-size: 1.25rem;"></i>
        </button>
      </c-nav-item>

      <!-- Settings -->
      <c-nav-item>
        <button 
          class="btn btn-link p-0 border-0 header-icon-btn"
          (click)="toggleAside()"
          cTooltip="Settings"
          placement="bottom"
        >
          <svg cIcon name="cilSettings" size="lg"></svg>
        </button>
      </c-nav-item>

      <!-- User Profile -->
      <c-nav-item>
        <ng-container *ngTemplateOutlet="userDropdown" />
      </c-nav-item>
    </c-header-nav>
  </c-container>
</c-header>
}
<button
  type="button"
  class="btn header-toggle-floating"
  [class.header-toggle-hidden]="hiddenHeader"
  (click)="toggleHeaderVisibility()"
>
  <i [class]="hiddenHeader ? 'cil-chevron-bottom' : 'cil-chevron-top'"></i>
</button>
<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle aria-label="Open user menu">
      <div class="user-avatar" [style.backgroundColor]="avatarBackgroundColor">
        {{ profile.initials }}
      </div>
    </button>
    <div cDropdownMenu>
      <a class="dropdown-item" [routerLink]="profileRoute">
        <i class="fa fa-user"></i> Profile
      </a>
      @if (canGoToTimeClock) {
      <a class="dropdown-item" [routerLink]="['/time-clock']">
        <i class="cil-clock"></i> Time clock
      </a>
      }
      <a class="dropdown-item pointer" (click)="logout()">
        <i class="fa fa-lock"></i> Logout
      </a>
    </div>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle aria-label="Open theme picker" class="theme-toggle-btn">
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (theme of unifiedThemes; track theme.name) {
      <button
        (click)="setUnifiedTheme(theme.name)"
        [active]="getCurrentUnifiedTheme() === theme.name"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" [name]="theme.icon" size="lg"></svg>
        {{ theme.text }}
      </button>
      }
    </div>
  </c-dropdown>
</ng-template>

<ng-template #pwdTemplate>
  <div class="modal-primary">
    <div class="modal-header">
      <h4 class="modal-title">Enter your password</h4>
    </div>
  </div>
  <form #form="ngForm" (ngSubmit)="redirectToWP(form)">
    <div class="modal-body">
      <div class="row">
        <div class="col">
          <label
            >Please enter your password to synchronize your user with the Field
            Tech Fitness support website.</label
          >
          <input
            type="password"
            class="form-control"
            name="password"
            required
            ngModel
          />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary">Ok</button>
    </div>
  </form>
</ng-template>